module.exports = __webpack_public_path__ + "images/emoji/cow2.dc0d297082d9aa52d1c8.png";